import {useApp} from "../../app/AppContext";
import {App as Application} from "../../app/AppSingleton";
import React from "react";
import {BoardInfo} from "./BoardInfo";

export function BoardFooter({children}:{children:any}) {
	const context = useApp();
	const app = Application.getInstance();
	/* Информация о доске */
	return <footer><BoardInfo board={app.getCurrentBoard()}/></footer>;
}